import React, { useCallback, useEffect } from 'react';
import { DetailPageParams, ListPageTypeId } from './types';
import { useSelector } from 'react-redux';
import { selectPageTypeId } from '../../modules/app/store';
import { usePageContextState } from '../../modules/page/hooks';
import { oldErrorPageClass, pageTypeIdsMatching } from '../../utils/const';
import { getPagePathId } from '../../utils/url';
import { useRecentlyViewedStorageAPI } from './hooks';
import useSearchParams from '../../hooks/useSearchParams';

const RecentlyViewedCleaner = ({ children }) => {
	const id = getPagePathId();
	const { organizationid } = useSearchParams({ caseInsensitive: true });

	const pageTypeIdFromDOM: ListPageTypeId = useSelector(selectPageTypeId);
	const { pageTypeId: pageTypeIdFromContext } = usePageContextState();
	const pageTypeId = pageTypeIdFromContext || pageTypeIdFromDOM;

	const getListPageTypeId = useCallback(() => {
		const pageTypeIds = pageTypeIdsMatching.find((ids) => {
			return ids.some((id) => id === Number(pageTypeId));
		});

		return typeof pageTypeIds !== 'undefined' ? pageTypeIds[0] : null;
	}, [pageTypeId]);

	const { removeRecentDetailPageData } = useRecentlyViewedStorageAPI({ listPageTypeId: getListPageTypeId() });

	useEffect(() => {
		const oldModuleOnNewRouteElement = document.querySelector(`.${oldErrorPageClass}`);
		const pageTypeId = getListPageTypeId();

		if (oldModuleOnNewRouteElement !== null && pageTypeId) {
			const detailPageParams: DetailPageParams = { id };

			if (typeof organizationid !== 'undefined') {
				detailPageParams.organizationid = organizationid;
			}

			removeRecentDetailPageData({ detailPageParams });
		}
	}, [getListPageTypeId, id, organizationid, removeRecentDetailPageData]);

	return <>{children}</>;
};

export { RecentlyViewedCleaner };
